// import createHistory from 'history';
const createHistory = require("history").createBrowserHistory;
export default createHistory();
